import { persistReducer } from "redux-persist";
import storage from "redux-persist/es/storage";
import { EBranchesActionTypes } from "./actions";

const defaultState = {
  branches: [],
  saving: false,
  savingError: false,
  savingSuccess: false,
  deleteSuccess: false,
  deleteFailed: false
};

const persistConfig = {
  key: "branches",
  storage,
  whitelist: ["branches"]
};

const branchesReducer = persistReducer(
  persistConfig,
  (state = defaultState, action) => {
    switch (action.type) {
      case EBranchesActionTypes.GET_BRANCHES_SUCCESS:
        return {
          ...state,
          branches: action.payload
        };
      case EBranchesActionTypes.SAVE_BRANCH:
        return {
          ...state,
          saving: true
        };
      case EBranchesActionTypes.SAVE_BRANCH_WITH_LOGO:
        return {
          ...state,
          saving: true
        };
      case EBranchesActionTypes.SAVING_FAILED:
        return {
          ...state,
          saving: false,
          savingError: Math.random(),
          savingSuccess: false
        };
      case EBranchesActionTypes.SAVING_SUCCESS:
        return {
          ...state,
          saving: false,
          savingError: false,
          savingSuccess: Math.random()
        };
      case EBranchesActionTypes.DELETING_SUCCESS:
        return {
          ...state,
          deleteSuccess: Math.random()
        };
      case EBranchesActionTypes.RESET_SUCCESS_DELETE:
        return {
          ...state,
          deleteSuccess: false
        };
      case EBranchesActionTypes.RESET_SUCCESS_SAVE:
        return {
          ...state,
          savingSuccess: false
        };
      default:
        return state;
    }
  }
);

export default branchesReducer;
